import { render, staticRenderFns } from "./ScreeningProgressAndResults.vue?vue&type=template&id=799773fb&scoped=true&"
import script from "./ScreeningProgressAndResults.vue?vue&type=script&lang=js&"
export * from "./ScreeningProgressAndResults.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProgressAndResults.vue?vue&type=style&index=0&id=799773fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799773fb",
  null
  
)

export default component.exports